module.exports = __webpack_public_path__ + "img/masa-hotel-almirante.cd507dce.jpg";